export const OAuth2Scopes = {
  PublicApi: {
    scope: 'data-collection/public-api',
    label: 'Public API',
    description: 'Access to the public DataCollection API endpoints',
  },

  PrivateApi: {
    scope: 'data-collection/private-api',
    label: 'Private API',
    description: 'Access to the private DataCollection API endpoints',
  },
} as const;
